'use strict';
const angular = require('angular');

export class PostInfoComponent {
  /*@ngInject*/
  constructor() {
  }

  getUserShort(user) {
    try {
      return (user) ? user.firstName + " " + user.lastName[0] + "." : "unknown";
    } catch(e) {
      return "unknown";
    }
  }
}

export default angular.module('conduuApp.postInfo', [])
  .component('postInfo', {
    template: `
      <i class="fa fa-clock-o fa-fw"></i> <span am-time-ago="ctrl.date"></span> 
      <i class="fa fa-fw fa-calendar-o"></i> {{ctrl.date | date:'mediumDate'}} 
      <i ng-if="ctrl.showUser && ctrl.user" class="fa fa-fw fa-user"></i> <a ng-if="ctrl.showUser && ctrl.user" href="/profile/user/{{ctrl.user._id}}">{{ctrl.getUserShort(ctrl.user)}}</a>
    `,
    bindings: {
      date: '<',
      user: '<',
      showUser: '<'
    },
    controller: PostInfoComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/post-info/post-info.component.js